<template>
	<div class="watch-readings-details-widget widget-alert-history">
		<div class="header">
			<router-link :to="{ name: alertHistoryRouteName, params: { user_uid: user_uid, watch_id: watch_id, type: type(type_id) } }">
				<h2>{{ $t('readings.general.alert_reports') }}</h2>
			</router-link>
			<router-link
				:to="{ name: alertHistoryRouteName, params: { user_uid: user_uid, watch_id: watch_id, type: type(type_id) } }"
				class="btn btn-small btn-round btn-primary"
				v-if="alerts.data.length">
				{{ $t('buttons.actions.view_all') }}
			</router-link>
		</div>
		<div class="body">
			<spinner v-if="alerts.loading" class="spinner"/>
			<div v-if="!alerts.loading && alerts.data.length" class="widget-table">
				<div class="widget-table-header">
					<div></div>
					<div>{{ $t('labels.general.name') }}</div>
					<div>{{ $t('labels.general.events') }}</div>
					<div>{{ $t('labels.general.first') }}</div>
					<div>{{ $t('labels.general.last') }}</div>
					<div>{{ $t('labels.general.date') }}</div>
					<div>{{ $t('labels.general.state') }}</div>
				</div>
				<div class="widget-table-body">
					<alert-history-row
						v-for="(item, index) in alerts.data"
						:key="item.id"
						v-model="alerts.data[index]"
						:user_uid="user_uid"
						:watch_id="watch_id"
						:type_id="type_id"
						:units="units"
						class="widget-table-row"/>
				</div>
			</div>
			<div v-if="!alerts.loading && !alerts.data.length" class="no-results">
				<p>{{ $t('readings.general.no_alerts') }}</p>
				<div class="actions" v-if="!alerts.data.length">
					<router-link
						:to="{ name: alertHistoryRouteName, params: { user_uid: user_uid, watch_id: watch_id, type: type(type_id) } }"
						class="btn btn-round btn-primary margin-0">
						{{ $t('buttons.actions.view_all') }}
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
import AlertHistoryRow from './rows/ReadingsWidgetAlertHistoryRow'
export default {
	components: {
		AlertHistoryRow
	},
	props: [
		'user_uid',
		'watch_id',
		'type_id',
	],
	data () {
		return {
			name: 'watch biometric alerts',
			alerts: {
				loading: false,
				error: null,
				data: []
			}
		}
	},
	computed: {
		units () {
			return this.type_id ? this.$t(Readings.readingTypes.get(parseInt(this.type_id)).translationKey + '.html') : '(no type)'
		},
		isGeofencing () {
			return parseInt(this.type_id) === Readings.TYPE_GEOFENCING
		},
		alertHistoryRouteName () {
			return this.isGeofencing ? 'WatchGeofencingAlertHistoryV2' : 'WatchBiometricAlertHistoryV2'
		}
	},
	methods: {
		getAlerts () {
			this.alerts.loading = true
			this.alerts.data = []
			this.$api.alerts.getAllResume(this, this.user_uid, this.watch_id, this.type_id)
				.then(response => {
					this.$log.info(this.name, 'alerts.getAll OK', response)()
					// STATUS_UNKNOWN = 0; STATUS_IN_PROGRESS = 1; STATUS_DONE = 2; STATUS_CANCEL = 4;
					this.alerts.data = response.body.filter(element => !(element.status > 1))
				}).catch(error => {
					this.$log.error(this.name, 'alerts.getAll ERROR', error)()
					this.alerts.error = error
				}).finally(() => {
					this.alerts.loading = false
				})
		},
		type (type) {
			return Readings.readingTypes.get(type).route
		},
		onRouteChanged () {
			// Next tick, otherwise type_id is not correct
			this.$nextTick(function () {
				this.getAlerts()
			})
		}
	},
	created () {
		this.$parent.$on('biometric-details-route-changed', this.onRouteChanged)
	},
	beforeDestroy () {
		this.$parent.$off('biometric-details-route-changed', this.onRouteChanged)
	},
	mounted () {
		this.getAlerts()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/ReadingsWidgetAlertHistory.vue